import React, { useState, useEffect } from "react";
import { Input, Button, Typography, Space } from "antd";
// import axios from "axios";

import { mclOpen } from "../../api/Mcl";
import { Url } from "../../constants/Global";

import { PasswordModal } from "../../components/PlanComponents"


const { TextArea } = Input;
const { Title } = Typography;

const initialQuestions = `
1. What is your name?
2. Who are you caring for and how is the person related to you?
3. What are your caregiving responsibilities?
4. What is the current health status of the person you care for?
5. What are the main challenges you face in caregiving?
6. What resources do you currently have available (family support, financial resources, etc.)?
7. What are your goals for the care plan?
8. What specific tasks do you need help with?
9. Are there any legal or financial considerations we should be aware of?
10. What is your preferred communication method?
11. How often do you need updates or check-ins?
12. What is your preferred level of involvement in the care plan?
`;
const initialPrompt = `You are a digital care planner. Based on the user’s description 
of their caregiving situation, generate a structured family care plan. 
Include categories: daily care, medical coordination, legal/financial tasks, emotional support, 
and contingency planning.`;


export const  DemoPlan2 = () => {
  const [qa, setQA] = useState(initialQuestions);
  const [prompt, setPrompt] = useState(initialPrompt);
  const [description, setDescription] = useState("generic care plan");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [authkey, setAuthkey] = useState(null);
  const [changekey, setChangekey] = useState(null);
  
  const validatePassword = () => {
    setAuthkey(changekey);
  }

  const handleProcess = async () => {
    setLoading(true);
    setResult("");
    console.log(Url.PLAN.concat("/ai"));
    try {      
      const response = await mclOpen.post(Url.PLAN.concat("/ai"),
        JSON.stringify({
          qa,
          prompt,
          description,
        }),
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      
      console.log("Response:", response?.data);
      setResult(response?.data || "No result returned.");
    } catch (err) {
      setResult(`Error processing request error: ${err.message}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    const compareHash = async (str) => {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
      console.log(str, hashHex);
      if (hashHex === "5d601c9f3f0339f619b6690cf01635231a8434f780e1e430096b91b4e3df5aab") {
        setIsAuthorized(true);
      } 
      // return hashHex;
    };

    if (!isAuthorized) {
      compareHash(changekey);
    }
  
    }, [authkey])

  // const PlanView = () => {

    return !isAuthorized
    ? <PasswordModal handleOk={validatePassword} modalShow={!isAuthorized} onKey={(val) => {setChangekey(val)}}/> : 
    (
      <div style={{ maxWidth: 700, margin: "40px auto" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div>
            <Title level={5}>LLM Prompt</Title>
            <Input.TextArea
              rows={6}
              value={prompt}
              onChange={e => setPrompt(e.target.value)}
              placeholder="Enter the prompt for LLM..."
            />
          </div>
          <div>
            <Title level={5}>Questions & Answers</Title>
            <Input.TextArea
              rows={15}
              value={qa}
              onChange={e => setQA(e.target.value)}
              placeholder="Enter your answers here..."
            />
          </div>
          <Button type="primary" onClick={handleProcess} loading={loading}>
            Generate Plan
          </Button>
          <div>
            <Title level={5}>Care Plan</Title>
            <Input.TextArea
              rows={30}
              value={result}
              readOnly
              placeholder="Result will appear here..."
            />
          </div>
        </Space>
      </div>
    );
  // }

  // return (
  //   !isAuthorized ? <PasswordModal handleOk={validatePassword} modalShow={!isAuthorized} onKey={(val) => {setChangekey(val)}}/> :
  //   <>
  //     <PlanView />
  //     <h4>authkey=={authkey}</h4>
  //   </>
  // )

}
